import React, { FC, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Radio,
  TextField,
  Typography,
} from "@mui/material";
import { ChevronDown as ExpandMoreIcon } from "mdi-material-ui";
import { IFiltroTurma } from "@deltasge/marauders-map";

interface Props {
  selecionado?: IFiltroTurma;
  turmas?: IFiltroTurma[];
  onClick: (id?: number) => void;
  render: "accordion" | "autocomplete";
  mostrarTodos: boolean;
}

export const FilterTurma: FC<Props> = ({
  selecionado,
  onClick,
  turmas,
  render,
  mostrarTodos,
}) => {
  const [panel, setPanel] = useState(false);

  const handleClick = (id?: number) => {
    onClick(id);
    if (render == "accordion") setPanel(false);
  };

  if (render == "accordion") {
    return (
      <Accordion
        elevation={0}
        expanded={panel}
        onChange={() => setPanel(!panel)}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Grid container>
            <Grid item xs={12} component={Typography} variant="subtitle2">
              Turma
            </Grid>
            <Grid item xs={12} component={Typography} variant="caption">
              {!selecionado ? "TODAS AS TURMAS" : selecionado?.tituloTurma}
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <List dense>
            {mostrarTodos && (
              <ListItemButton onClick={() => handleClick()}>
                <ListItemIcon>
                  <Radio checked={undefined == selecionado} />
                </ListItemIcon>
                <ListItemText primary="TODAS AS TURMAS" />
              </ListItemButton>
            )}
            {turmas?.map((turma) => (
              <ListItemButton
                key={`filter-turma-${turma.id}`}
                onClick={() => handleClick(turma.id)}
              >
                <ListItemIcon>
                  <Radio checked={turma.id == selecionado?.id} />
                </ListItemIcon>
                <ListItemText
                  primary={turma.tituloTurma?.rUpper()}
                  primaryTypographyProps={{
                    noWrap: true,
                  }}
                />
              </ListItemButton>
            ))}
          </List>
        </AccordionDetails>
      </Accordion>
    );
  }

  return (
    <Autocomplete
      sx={{ m: 1 }}
      disablePortal
      id="filter-turma"
      options={turmas ?? []}
      value={selecionado}
      renderInput={(params) => <TextField {...params} label="Turma" />}
      getOptionLabel={(option) => option.tituloTurma?.rUpper() ?? ""}
      onChange={(event, value) => handleClick(value?.id)}
      noOptionsText="Selecione uma série"
      clearText="Todos as turmas"
      openText="Selecione uma turma"
      renderOption={(props, option) => (
        <ListItem {...props}>
          <ListItemText
            key={option.id}
            primary={option.tituloTurma?.rUpper()}
            primaryTypographyProps={{
              noWrap: true,
            }}
          />
        </ListItem>
      )}
    />
  );
};
